import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { HashRouter } from "react-router-dom";
import { Table, Space, Button, Breadcrumb } from "antd";
import "./index.less";
import { Route, Switch, useHistory, Link, Redirect } from "react-router-dom";
import { LearnRecord } from "./learnRecord";
import { ProjectCollection } from "./projectCollection";
import { OnLineByCard } from "./onLineByCard";
import { OrderRecord } from "./orderRecord/index";
import { OnlineCardBind } from "./onlineCardBind";
import { CardBindRecord } from "./cardBindRecord";
import { MessageBoard } from "./messageBoard";
import { HasPayProject } from "./hasPayProject";
import UpdateUserInfo from "../updateUserInfo";
import LearnExplain from "./LearnExplain/index";
import NormalQuestion from "./NormalQuestion/index";
import ContactUs from "./ContactUs/index";
interface Props extends DefaultProps {
  routes: any[];
  storeData: any;
}
const creditMode = [
  {
    title: "修改信息",
    value: "updateUserInfo",
    component: UpdateUserInfo,
  },
  {
    title: "学习记录",
    value: "learnRecord",
    component: LearnRecord,
  },
  {
    title: "项目收藏",
    value: "projectCollection",
    component: ProjectCollection,
  },
  {
    title: "在线购卡",
    value: "onLineByCard",
    component: OnLineByCard,
  },
  {
    title: "订单记录",
    value: "orderRecord",
    component: OrderRecord,
  },
  {
    title: "在线绑卡",
    value: "onlineCardBind",
    component: OnlineCardBind,
  },
  {
    title: "绑卡记录",
    value: "cardBindRecord",
    component: CardBindRecord,
  },
  {
    title: "留言板",
    value: "messageBoard",
    component: MessageBoard,
  },
  {
    title: "学习说明",
    value: "learnExplain",
    component: LearnExplain,
  },
  {
    title: "常见问题",
    value: "normalQuestion",
    component: NormalQuestion,
  },
  {
    title: "联系我们",
    value: "contactUs",
    component: ContactUs,
  },
];
const payMode = [
  {
    title: "修改信息",
    value: "updateUserInfo",
    component: UpdateUserInfo,
  },
  {
    title: "项目收藏",
    value: "projectCollection",
    component: ProjectCollection,
  },
  {
    title: "已购项目",
    value: "hasPayProject",
    component: HasPayProject,
  },
  {
    title: "订单记录",
    value: "orderRecord",
    component: OrderRecord,
  },
  {
    title: "留言板",
    value: "messageBoard",
    component: MessageBoard,
  },
  {
    title: "学习说明",
    value: "learnExplain",
    component: LearnExplain,
  },
  {
    title: "常见问题",
    value: "normalQuestion",
    component: NormalQuestion,
  },
  {
    title: "联系我们",
    value: "contactUs",
    component: ContactUs,
  },
];
const PersonCenter: FC<Props> = ({ routes = [], storeData, history }) => {
  const { userInfo } = storeData;
  console.log("routes", routes);
  console.log("storeData", storeData);
  const {
    userInfo: { chargeMode },
  } = storeData;
  let isOrderRecord = window.location.href.includes("wechatPay");
  let from = window.location.href.includes("from");
  let isAliPay = window.location.href.includes("currentPayTradeNo");
  const router: any = new HashRouter({});
  const [navList, setNavList] = useState(
    chargeMode === 1 ? creditMode : payMode
  );
  useEffect(() => {}, []);
  return (
    <div className={"learnRecords"}>
      <div className="nav-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>个人中心</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className={"content"}>
        <div className={"left"}>
          <div className={"img-box"}>
            <img src={userInfo?.avatar} alt="" />
          </div>
          <div className={"username"}>{userInfo?.name}</div>
          <div
            className={"myCenter"}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            {navList.map((item) => {
              return (
                <Button
                  key={item.value}
                  type="primary"
                  onClick={() => {
                    console.log("history", history);
                    if (item.value === "updateUserInfo") {
                      router.history.push("/updateUserInfo");
                    } else {
                      router.history.push(`/index/personCenter/${item.value}`);
                    }
                  }}
                  style={{
                    color:
                      `/index/personCenter/${item.value}` ===
                      history.location.pathname
                        ? "black"
                        : "white",
                  }}
                >
                  {item.title}
                </Button>
              );
            })}
          </div>
        </div>
        <div className={"right"}>
          <Switch>
            {navList.map((item) => (
              <Route
                path={`/index/personCenter/${item.value}`}
                component={item.component}
              />
            ))}
            {/* <Redirect
              path="/index/personCenter/"
              exact={true}
              to="/index/personCenter/learnRecord"
            /> */}
          </Switch>
        </div>
      </div>
    </div>
  );
};
export default connect((state) => state)(PersonCenter);
